import { createSlice } from '@reduxjs/toolkit'
import authservice from '../../services/authservice';

const initialState = {
    user: authservice.getUserInfo(),
    accessToken: authservice.getAccessToken(),
    isLoggedIn: authservice.withAccessToken(),
    loading: false,
    error: null,
    navigatePath: '',
    modules: JSON.parse(localStorage.getItem("allowedModules") || "[]"),
    userProfile:{
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    forgotPasswordMsg: null,
    resetPassword: {
        error: null,
        success: false,
        message: null,
    },
    originalUserUserAccessToken: authservice.getOriginalUserAccessToken(),
    isImpersonating: authservice.getIsImpersonating(),
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginRequest: (state) => {
        state.loading = true;
        state.error = null;
    },
    loginSuccess: (state, action) => {
        state.loading = false;
        state.isLoggedIn = true;
        state.accessToken = action.payload;
        state.error = null;
    },
    loginFail: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },
    logoutRequest: (state) => {
        state.loading = true;
        state.error = null;
    },
    logoutSuccess: (state) => {
        state.loading = false;
        state.isLoggedIn = false;
        state.user = null;
        state.accessToken = null;
        state.error = null;
    },
    logoutFail: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },
    getAuthUser: (state) => {
        state.loading = true;
        state.error = null;
    },
    getAuthUserSuccess: (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
    },
    getAuthUserFail: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },
    getAuthUserModule: (state) => {
        state.loading = true;
        state.error = null;
    },
    getAuthUserModuleSuccess: (state, action) => {
        state.loading = false;
        localStorage.setItem("allowedModules", JSON.stringify(action.payload));
        state.modules = action.payload;
        state.error = null;
    },
    getAuthUserModuleFail: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },
    navigateTo: (state, action) => {
        state.navigatePath = action.payload;
    },
    getUserProfile: (state) => {
        state.userProfile.requesting = true;
        state.userProfile.error = null;
        state.userProfile.data = null;
        state.userProfile.success = false;
    },
    getUserProfileSuccess: (state, action) => {
        state.userProfile.requesting = false;
        state.userProfile.data = action.payload;
        state.userProfile.success = true;
    },
    getUserProfileFail: (state, action) => {
        state.userProfile.requesting = false;
        state.userProfile.error = action.payload;
    },
    doChangePassword: (state) => {
        state.loading = true;
        state.error = null;
    },
    doChangePasswordSuccess: (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
    },
    doChangePasswordFail: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },
    doForgotPassword: (state) => {
        state.loading = true;
        state.error = null;
        state.forgotPasswordMsg = null;
    },
    doForgotPasswordSuccess: (state, action) => {
        state.loading = false;
        state.forgotPasswordMsg = action.payload;
        state.error = null;
    },
    doForgotPasswordFail: (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.forgotPasswordMsg = action.payload;
    },
    doResetPassword: (state) => {
        state.loading = true;
        state.resetPassword.error = null;
        state.resetPassword.success = false;
    },
    doResetPasswordSuccess: (state, action) => {
        state.loading = false;
        state.error = null;
        state.resetPassword.success = true;
        state.resetPassword.message = action.payload;
    },
    doResetPasswordFail: (state, action) => {
        state.loading = false;
        state.resetPassword.error = action.payload;
        state.resetPassword.success = false;
    },
    loginAsUser: (state) => {
        state.loading = true;
        state.error = null;
    },
    loginAsUserSuccess: (state, action) => {
        state.loading = false;
        state.isLoggedIn = true;
        state.accessToken = action.payload;
        state.isImpersonating = 1;
        state.error = null;
    },
    loginAsUserFail: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },

    logoutAsUser: (state) => {
        state.loading = true;
        state.error = null;
    },

    logoutAsUserSuccess: (state, action) => {
        state.loading = false;
        state.isImpersonating = 0;
        state.accessToken = action.payload;
        state.error = null;
    },

  },
})

export const { 
    loginRequest, loginSuccess, loginFail,
    logoutRequest, logoutSuccess, logoutFail,
    getAuthUser, getAuthUserSuccess, getAuthUserFail,
    getAuthUserModule, getAuthUserModuleSuccess, getAuthUserModuleFail,
    navigateTo,
    getUserProfile, getUserProfileSuccess, getUserProfileFail,
    doChangePassword, doChangePasswordSuccess, doChangePasswordFail,
    doForgotPassword, doForgotPasswordSuccess, doForgotPasswordFail,
    doResetPassword, doResetPasswordSuccess, doResetPasswordFail,
    loginAsUser, loginAsUserSuccess, loginAsUserFail,
    logoutAsUser, logoutAsUserSuccess
} = authSlice.actions

export default authSlice.reducer